import { render, staticRenderFns } from "./site-delete.vue?vue&type=template&id=573d865f&scoped=true"
import script from "./site-delete.vue?vue&type=script&lang=js"
export * from "./site-delete.vue?vue&type=script&lang=js"
import style0 from "./site-delete.vue?vue&type=style&index=0&id=573d865f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573d865f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573d865f')) {
      api.createRecord('573d865f', component.options)
    } else {
      api.reload('573d865f', component.options)
    }
    module.hot.accept("./site-delete.vue?vue&type=template&id=573d865f&scoped=true", function () {
      api.rerender('573d865f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/site/site-delete.vue"
export default component.exports